import { Route, RouteObject } from 'react-router-dom';
import ReconnectionLandingPage from './components/landing/landing';
import { CreateReconnectionRequest } from './components';
import ReconnectionReceipt from './components/receipt/receipt';
import ReconnectionRequestDetailPage from './components/details/details';
import ReconnectionSuccessPage from './components/receipt/receipt';


export interface reconnectionRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: reconnectionRoute[];
}

export const reconnectionRoutes: reconnectionRoute[] = [
    {
        path: 'cx/reconnections',
        element: <ReconnectionLandingPage />,
      },
    {
      path: 'cx/reconnections/create',
      element: <CreateReconnectionRequest />,
    },
    {
      path: 'cx/reconnections/create/:step',
      element: <CreateReconnectionRequest />,
    },
    {
      path: 'cx/reconnections/receipt',
      element: <ReconnectionReceipt />,
    },
    // {
    //   path: 'cx/reconnections/:id',
    //   element: <ReconnectionRequestDetailPage />,
    // },
    {
      path: 'cx/reconnections/success',
      element: <ReconnectionSuccessPage />,
    },

      {
    path: "cx/reconnections/:action/:id",
    element: <ReconnectionRequestDetailPage />,
  },
  {
    path: "cx/reconnections/:action/:id",
    element: <ReconnectionRequestDetailPage />,
  },
];
